export default class Header {

  constructor(el) {
    this.el = el
    this.hamburger = el.querySelector('.hamburger')
    this.menu = el.querySelector('.header--menu')
    this.nav = el.querySelector('.header--nav')
    this.switcher = el.querySelector('.header--switcher')
    this.langueBtn = el.querySelector('.header--langue')

    if (!this.hamburger) return

    this.bindHamburger()
    this.bindScroll()
    this.bindLangue()
  }

  bindHamburger() {
    this.hamburger.addEventListener('click', () => {
      const isOpen = this.hamburger.classList.toggle('is-active')
      this.menu?.classList.toggle('is-full')
      this.nav?.classList.toggle('menu-open', isOpen)

      if (isOpen) window.lenis?.stop()
      else window.lenis?.start()
    })
  }

  bindLangue() {
    if (!this.langueBtn || !this.switcher) return

    this.langueBtn.addEventListener('click', (e) => {
      e.stopPropagation()
      this.switcher.classList.toggle('isOpen')
    })

    document.addEventListener('click', (e) => {
      if (!this.switcher.contains(e.target)) {
        this.switcher.classList.remove('isOpen')
      }
    })
  }

  bindScroll() {
    const onScroll = () => {
      this.nav?.classList.toggle('is-scrolled', window.scrollY > 50)
    }
    window.addEventListener('scroll', onScroll, { passive: true })
    onScroll()
  }

}
